import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { Avatar, Box, Card, Stack, Typography } from "@mui/material";

const ServiceCard = ({ service, index }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useWindowSize();

  return isMobile ? (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        borderRadius: 2,
        border: "1px solid #EBEDF1",
        px: 2.5,
        py: 2,
        gap: 2,
        "&:hover": { boxShadow: "0 2px 10px rgba(20,30,50,0.06)" },
        transition: "box-shadow .15s ease",
        cursor: "pointer",
      }}
    >
      <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Stack direction={"row"} spacing={1.5} alignItems='center'>
          <Avatar sx={{ bgcolor: "#003C59", width: 34, height: 34, fontSize: 14, fontWeight: 700 }}>{index + 1}</Avatar>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, mb: 0.5 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#1A2233" }}>{service?.translations[i18n.language]?.name}</Typography>
          </Box>
        </Stack>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-evenly" }}></Box>
      </Box>
    </Card>
  ) : (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderRadius: 2,
        border: "1px solid #EBEDF1",
        px: 2.5,
        py: 2,
        gap: 2,
        "&:hover": { boxShadow: "0 2px 10px rgba(20,30,50,0.06)", borderLeft: `4px solid #00C9DB` },
        transition: "box-shadow .15s ease",
        cursor: "pointer",
      }}
    >
      <Avatar sx={{ bgcolor: "#003C59", width: 34, height: 34, fontSize: 14, fontWeight: 700 }}>{index + 1}</Avatar>
      <Box sx={{ display: "flex", justifyContent: "space-between", flex: 1, minWidth: 0 }}>
        <Box sx={{ flex: 1, minWidth: 0, gap: 1, display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 0.5 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#1A2233" }}>{service?.translations[i18n.language]?.name}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
            <Typography variant='body2' sx={{ color: "text.secondary", mr: 2 }}>
              {service?.translations[i18n.language]?.description}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 4, justifyContent: "space-evenly" }}></Box>
      </Box>
    </Card>
  );
};

export default ServiceCard;
